import { useEffect } from "react";
import { createPortal } from "react-dom";
import styles from "./BottomPage.module.css";

export default function BottomPage({ isOpen, onClose, children }) {
  // جلوگیری از scroll پشت modal
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return createPortal(
    <div className={styles.overlay} onClick={onClose}>
      <div
        className={styles.sheet}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.handle} />
        {children}
      </div>
    </div>,
    document.body
  );
}